module.exports = __webpack_public_path__ + "static/media/autobiography.241a380e.png";